export default __webpack_public_path__ + "static/media/Hair_7_M_C2.e29a69c4.svg";